<template>
  <div class="chat-element-text-top">
    <img :src="require('@/assets/AI.png')" class="ai-avatar" />
    <span class="rebot-name text-color">招小科：</span>
    <div class="right">
      <div v-if="loading">
        <img src="@/assets/icon/loading_point.gif" class="loading-icon" />
      </div>
      <div v-else>
        <div class="right-content text-color">
          {{ content }}
        </div>
        <div class="recommend-btns" v-if="messageItem.type === 'wakeup'">
          <div
            v-for="(item, rIndex) in recommendList"
            :key="rIndex"
            class="recommend-btn"
          >
            <i
              :class="item.icon"
              :style="{ color: item.color, cursor: 'pointer' }"
            ></i>
            <span class="recommend-btn-label">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--  <SpeechRecognitionAssistantSpeak
      ref="SpeechRecognitionAssistantSpeak"
    ></SpeechRecognitionAssistantSpeak> -->
  </div>
</template>

<script>
// import SpeechRecognitionAssistantSpeak from "@/components/speech-recognition-assistant/speak.vue";

export default {
  // components: { SpeechRecognitionAssistantSpeak },
  props: {
    messageItem: {
      type: Object,
    },
    index: {
      type: Number,
      require: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
    },
  },
  data() {
    return {
      recommendList: [
        {
          icon: "el-icon-notebook-1",
          color: "#307CF7",
          label: "推荐功能",
        },
        {
          icon: "el-icon-tickets",
          color: "#10D482",
          label: "推荐功能",
        },
        {
          icon: "el-icon-s-opportunity",
          color: "#FFD600",
          label: "推荐功能",
        },
      ],
    };
  },
  methods: {
    speak() {
      speechSynthesis.cancel(); // 全部关闭
    },

    copy() {
      this.$copyText(this.content)
        .then((message) => {
          this.$message("复制成功");
        })
        .catch((err) => {
          this.$message.error("复制失败");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.chat-element-text-top {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: "Microsoft YaHei";
  font-size: 12rpx;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 6px 0;
  .text-color {
    background: linear-gradient(to right, #79e9db, #6298ff);
    -webkit-background-clip: text;
    color: transparent;
  }
  .rebot-name {
    min-width: 50px;
  }
  .ai-avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  .right {
    display: flex;
    align-items: center;
    .loading-icon {
      width: 24px;
      height: 6px;
    }

    .right-content {
      user-select: text;
    }
    .recommend-btns {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 5px;
      .recommend-btn {
        border-radius: 16px;
        border: 1px solid #428ef2;
        background: #428ef266;
        margin-right: 8px;
        padding: 2px 8px;
        .recommend-btn-label {
          color: #fff;
          font-size: 12rpx;
          font-weight: 200;
          letter-spacing: 0.72px;
          opacity: 0.8;
          margin-left: 3px;
        }
      }
    }
  }
}
</style>
